import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {catchError, map} from "rxjs/operators";
import {any} from "codelyzer/util/function";
import {EMPTY, Observable, throwError} from "rxjs";
import {GovBrService} from "./govbr.service";
import {environment} from "../../environments/environment";

@Injectable({
	providedIn: 'root'
})

export class AcompanhamentoService {

	constructor(
		private http: HttpClient,
		private govBrService: GovBrService,
	) { }

	acompanhamento(request: 'registrar' | 'finalizar', protocolo: any): Observable<any> {

		let user = this.govBrService.getLocalItem('login-planmob');

		let params = {
			cpfCidadao: user.num_cpf,
			protocolo: protocolo,
		}

		return this.http.post(`${environment.api_url}/acompanhamento/${request}`,params).pipe(map((response: any) => {
				return response;
			}),catchError((error) => {
				return error.message
			})
		);
	}

	notificarGestor(protocolo: any):Observable<any> {

		let user = this.govBrService.getLocalItem('login-planmob');

		let params = {
			cpfCidadao: user.num_cpf,
			protocolo: protocolo,
		}

		return this.http.post(`${environment.api_url}/avaliacao/notifygestorbymail`, params).pipe(
			map((response: any) => {
				return response;
			}),
			catchError((error) => {
				return throwError(error.error);
			}),
		);
	}
}
